<template>
  <div class="child-form">

    <hr
      class="full-width-divider"
      v-if="index > 0"
    >

    <h5 v-if="showTitles">Child {{ index + 1 }}</h5>

    <div class="input-wrap">
      <label>Child's first name</label>
      <input
        type="text"
        class="first-name"
        v-model="childName"
        @keydown="incrementInput"
      >
    </div>

    <div class="input-wrap">
      <label>Child's last name</label>
      <input
        type="text"
        class="last-name"
        @keydown="incrementInput"
      >
    </div>

    <div class="input-wrap dob-wrap">
      <p>
        Child’s date of birth
      </p>
      <label>
        <div class="select-wrapper">
          <select class="day">
            <option
              selected="selected"
              disabled="disabled"
              hidden="hidden"
              value=""
            />
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
            <option value="17">17</option>
            <option value="18">18</option>
            <option value="19">19</option>
            <option value="20">20</option>
            <option value="21">21</option>
            <option value="22">22</option>
            <option value="23">23</option>
            <option value="24">24</option>
            <option value="25">25</option>
            <option value="26">26</option>
            <option value="27">27</option>
            <option value="28">28</option>
            <option value="29">29</option>
            <option value="30">30</option>
            <option value="31">31</option>
          </select>
        </div>
        <span class="hint">Day</span>
      </label>
      <label>
        <div class="select-wrapper">
          <select class="month">
            <option
              selected="selected"
              disabled="disabled"
              hidden="hidden"
              value=""
            />
            <option value="1">January</option>
            <option value="2">February</option>
            <option value="3">March</option>
            <option value="4">April</option>
            <option value="5">May</option>
            <option value="6">June</option>
            <option value="7">July</option>
            <option value="8">August</option>
            <option value="9">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>
        </div>
        <span class="hint">Month</span>
      </label>
      <label>
        <div class="select-wrapper">
          <select
            class="year"
            @input="incrementInput"
          >
            <option
              selected="selected"
              disabled="disabled"
              hidden="hidden"
              value=""
            />
            <option value="2018">2018</option>
            <option value="2017">2017</option>
            <option value="2016">2016</option>
            <option value="2015">2015</option>
            <option value="2014">2014</option>
            <option value="2013">2013</option>
            <option value="2012">2012</option>
            <option value="2011">2011</option>
            <option value="2010">2010</option>
            <option value="2009">2009</option>
            <option value="2008">2008</option>
            <option value="2007">2007</option>
            <option value="2006">2006</option>
            <option value="2005">2005</option>
            <option value="2004">2004</option>
            <option value="2003">2003</option>
            <option value="2002">2002</option>
            <option value="2001">2001</option>
            <option value="2000">2000</option>
          </select>
        </div>
        <span class="hint">Year</span>
      </label>
    </div>

    <div>
      <a
        v-if="index > 0"
        @click="removeChild"
      >
        <i
          class="fa fa-times"
          aria-hidden="true"
        /> Remove this child
      </a>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: 1
    },
    'show-titles': {
      type: Boolean,
      default: false
    },
    child: {
      type: String,
      default: ''
    }
  },
  mounted: function () {
    this.childName = this.child
  },
  data: function () {
    return {
      childName: ''
    }
  },
  watch: {
    childName: function (val, oldVal) {
      this.$emit('update-child', {position: this.index, name: val})
    }
  },
  methods: {
    removeChild: function () {
      this.$emit('remove-child', {position: this.index, name: this.childName})
    },
    incrementInput: function (event) {
      this.$emit('increment-input', event)
    }
  }
}
</script>

<style lang="scss" scoped>

  .child-form {
    margin-bottom: 1.5em;
  }

  // Temp override for signup.scss module
  @media only screen and (min-width: 1024px) {
    .input-wrap.dob-wrap {
        width: 100%;
        float: none;
        margin-left: auto;
    }
  }

  .input-wrap.dob-wrap {
    color: #2b2b2b;
  }

</style>



// WEBPACK FOOTER //
// src/components/library/child.vue